var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.selectedComponent)?_c('Comp_choice',{on:{"select-component":_vm.updateComponent}}):_vm._e(),_c(_vm.selectedComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }